'use client';
import { FC } from 'react';

interface HighlightedTextProps {
  text: string;
  highlightClassName?: string;
  blueHighlightClassName?: string;
  className?: string;
}

const HighlightedText: FC<HighlightedTextProps> = ({
  text,
  className = '',
  highlightClassName = 'text-[#05F273]',
  blueHighlightClassName = 'text-[#21007c]',
}) => {
  // Split on both [highlight]...[/highlight] and [highlight_b]...[/highlight_b]
  const parts = text.split(
    /(\[highlight\][^]*?\[\/highlight\]|\[highlight_b\][^]*?\[\/highlight_b\])/g,
  );

  const renderWithLineBreaks = (str: string) => {
    return str.split('\n').map((line, i, arr) => (
      <span key={i}>
        {line}
        {i < arr.length - 1 && <br />}
      </span>
    ));
  };

  return (
    <span className={className}>
      {parts.map((part, i) => {
        // Green highlight
        const greenMatch = part.match(/\[highlight\]([^]*?)\[\/highlight\]/);
        if (greenMatch) {
          return (
            <span key={i} className={highlightClassName}>
              {renderWithLineBreaks(greenMatch[1])}
            </span>
          );
        }
        // Blue highlight
        const blueMatch = part.match(/\[highlight_b\]([^]*?)\[\/highlight_b\]/);
        if (blueMatch) {
          return (
            <span key={i} className={blueHighlightClassName}>
              {renderWithLineBreaks(blueMatch[1])}
            </span>
          );
        }
        return <span key={i}>{renderWithLineBreaks(part)}</span>;
      })}
    </span>
  );
};

export default HighlightedText;
